module.exports = __webpack_public_path__ + "img/deptInfoA.1d2c4aa6.png";